import { useState } from "react"
import { RecurringDonation } from "../types"
import RecurringDonationDetails from "./RecurringDonationDetails"
import { PaymentMethodsProvider } from "../hooks/usePaymentMethodsContext"
import { Heading } from "@planningcenter/doxy-web"
import { Link } from "react-router-dom"

interface RecurringDonationsListProps {
  recurringDonations: RecurringDonation[]
  showFullDetails: boolean
}

export default function RecurringDonationsList({
  recurringDonations,
  showFullDetails,
}: RecurringDonationsListProps) {
  return (
    <PaymentMethodsProvider>
      <RecurringDonationsListContent
        recurringDonations={recurringDonations}
        showFullDetails={showFullDetails}
      />
    </PaymentMethodsProvider>
  )
}

function RecurringDonationsListContent({
  recurringDonations,
  showFullDetails,
}: RecurringDonationsListProps) {
  const [donations, setDonations] =
    useState<RecurringDonation[]>(recurringDonations)
  const [isEditingId, setIsEditingId] = useState<string | null>(null)

  function handleEdit(id: string | null) {
    setIsEditingId(id)
  }

  function onDelete(deletedDonation: RecurringDonation) {
    const updatedDonations = donations.filter(
      (donation) => donation.id !== deletedDonation.id,
    )
    setDonations(updatedDonations)
  }

  return (
    <>
      {donations.length === 0 ? (
        <div className="d-f fd-c action-drawer ta-c py-3 px-4 g-1">
          <div className="d-f jc-c">
            <img src="/static/recurring-gift.svg" alt="" width="32" />
          </div>
          <Heading
            level={3}
            size={3}
            color="tint1"
            text="No recurring gifts yet"
          />
          <p className="fw-500 c-tint2 mb-0">
            Consistent giving helps our church to plan confidently for ministry
            and outreach. Every faithful gift makes an impact.
          </p>
          <div>
            <Link className="btn md-btn" to="/giving?recurring=true">
              Schedule a recurring gift
            </Link>
          </div>
        </div>
      ) : (
        <>
          {donations.map((donation: RecurringDonation) => (
            <RecurringDonationDetails
              key={donation.id}
              recurringDonation={donation}
              showFullDetails={showFullDetails}
              onEdit={handleEdit}
              isDisabled={isEditingId ? isEditingId !== donation.id : false}
              onDelete={onDelete}
            />
          ))}
        </>
      )}
    </>
  )
}
